const vendorsPrefixes = ["ms", "moz", "webkit", "o"];
let cAF = window.cancelIdleCallback;

if (!cAF) {
  cAF = vendorsPrefixes.find(prefix => window[`${prefix}CancelIdleCallback`]);
}

if (!cAF) {
  cAF = clearTimeout;
}

function cancelIdleCallback(requestId) {
  cAF(requestId);
}

export default cancelIdleCallback;
